module.exports = __webpack_public_path__ + "media/images/landing/second/photo26-625e052b6c7a1a36026aa1286f32c557.jpg";